import { Box, HStack, IconButton, SimpleGrid, Text } from "@chakra-ui/react";
import { FaMinus, FaPlus } from "react-icons/fa";
import { useUITheme } from "../../context/ThemeContext";
import { STOP_CATEGORIES } from "../../features/planner/categories";

export default function CategorySelectors({ quantities, onChange }) {
  const theme = useUITheme();
  const total = Object.values(quantities).reduce((sum, value) => sum + Number(value || 0), 0);
  return (
    <Box>
      <HStack justify="space-between" mb={2} align="end">
        <Box>
          <Text fontSize="xs" fontWeight="extrabold" letterSpacing="0.12em">CHOOSE YOUR STOPS</Text>
          <Text fontSize="xs" opacity={0.65}>Up to 5 of each type and 10 in total.</Text>
        </Box>
        <Text color={theme.primary} fontSize="lg" fontWeight="extrabold">{total}/10</Text>
      </HStack>
      <SimpleGrid columns={2} spacing={0} border="1px solid" borderColor={theme.accent} borderRadius="2xl" overflow="hidden" bg={`${theme.accent}0b`}>
        {STOP_CATEGORIES.map(({ id, label, icon: Icon, color }, index) => {
          const value = Number(quantities[id] || 0);
          const active = value > 0;
          const cannotAdd = value >= 5 || total >= 10;
          return (
            <Box
              key={id}
              position="relative"
              px={3}
              py={2.5}
              borderRight={index % 2 === 0 ? "1px solid" : "none"}
              borderBottom={index < STOP_CATEGORIES.length - 2 ? "1px solid" : "none"}
              borderColor={theme.accent}
            >
              <Box position="absolute" left={0} top={2} bottom={2} w="3px" borderRightRadius="full" bg={active ? color : "transparent"} />
              <HStack spacing={2} minW={0} mb={2}>
                <Icon color={active ? color : theme.text} opacity={active ? 1 : 0.55} size="1.05em" />
                <Text fontSize="xs" fontWeight={active ? "extrabold" : "bold"} noOfLines={1}>{label}</Text>
              </HStack>
              <HStack spacing={1} border="1px solid" borderColor={theme.accent} borderRadius="full" p="2px" bg={theme.bg}>
                <IconButton
                  aria-label={`Decrease ${label}`}
                  icon={<FaMinus />}
                  size="xs"
                  minW="30px"
                  h="30px"
                  isRound
                  variant="ghost"
                  color={theme.text}
                  opacity={value ? 1 : 0.32}
                  isDisabled={!value}
                  onClick={() => onChange(id, value - 1)}
                  _hover={{ bg: `${color}18`, color }}
                  _disabled={{ opacity: 0.32, cursor: "not-allowed" }}
                />
                <Text flex={1} textAlign="center" fontSize="sm" fontWeight="extrabold" color={active ? theme.text : `${theme.text}88`}>{value}</Text>
                <IconButton
                  aria-label={`Increase ${label}`}
                  icon={<FaPlus />}
                  size="xs"
                  minW="30px"
                  h="30px"
                  isRound
                  bg={color}
                  color="white"
                  isDisabled={cannotAdd}
                  onClick={() => onChange(id, value + 1)}
                  _hover={{ bg: color, color: "white", filter: "brightness(0.9)" }}
                  _active={{ bg: color, transform: "scale(.96)" }}
                  _disabled={{ opacity: 0.3, cursor: "not-allowed" }}
                />
              </HStack>
            </Box>
          );
        })}
      </SimpleGrid>
    </Box>
  );
}
